import type { AppSnapshot, GoalSettings } from "../ui/types";

export const DEFAULT_GOAL_SETTINGS: GoalSettings = Object.freeze({
  kind: "maintain",
  weeklyRatePercent: 0.5,
  maintenanceGoalWeightKg: 80,
  maintenanceTolerancePercent: 1,
  checkInDay: 0,
  carbohydrateShareOfRemainder: 0.55,
  fatShareOfRemainder: 0.45,
});

export function createEmptySnapshot(today: string, isOnline: boolean): AppSnapshot {
  return {
    needsOnboarding: true,
    todayDate: today,
    todayLabel: formatLongDate(today),
    isOnline,
    week: {
      startsOn: today,
      endsOn: today,
      baselineDailyCalories: 0,
      weeklyBudgetCalories: 0,
      fixedDailyProteinGrams: 0,
      carbohydrateShareOfRemainder: DEFAULT_GOAL_SETTINGS.carbohydrateShareOfRemainder,
      fatShareOfRemainder: DEFAULT_GOAL_SETTINGS.fatShareOfRemainder,
      days: [],
    },
    weight: {
      unit: "kg",
      rollingAverageSampleSize: 0,
      points: [],
    },
    checkIn: {
      status: "not-due",
      dueDate: today,
      nominatedDayLabel: weekdayName(DEFAULT_GOAL_SETTINGS.checkInDay),
      isLoggingLocked: false,
      allowedBackfillDates: [],
      previousBaselineCalories: 0,
      recommendedBaselineCalories: 0,
      minimumRecommendedCalories: 1_200,
      maximumRecommendedCalories: 5_000,
      trendWeightSampleSize: 0,
      proposedProteinGrams: 0,
      dailyFloorPolicy: {
        absoluteMinimumCalories: 1_200,
        minimumNonProteinCalories: 400,
        minimumFatGrams: 40,
      },
      noWeightData: true,
    },
    goals: { ...DEFAULT_GOAL_SETTINGS },
    nutrientGoals: [],
    backup: {
      driveConnected: false,
      backupPending: false,
      isBusy: false,
    },
  };
}

export function weekdayName(day: number): string {
  return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][day] ?? "Unknown";
}

export function formatLongDate(date: string): string {
  return new Date(`${date}T12:00:00`).toLocaleDateString(undefined, {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
}
